import { ShortCode } from '@highereducation/wordpress';
import { Avatar } from '@highereducation/hen-ui';

type AvatarShortcodeProps = {
  src?: string;
  alt?: string;
  fallback?: string;
  size?: 'sm' | 'md' | 'lg';
  badge?: string | boolean;
  [key: string]: unknown;
};

/**
 * AvatarShortcode - Shortcode wrapper for the Avatar atomic (image with initials fallback).
 *
 * Supported shortcode attributes:
 * - src: Avatar image URL (optional — falls back to initials)
 * - alt: Alt text for accessibility (required when src is set)
 * - fallback: Initials shown when no image (e.g. "RL")
 * - size: 'sm' | 'md' | 'lg'
 * - badge: "true" to render the status badge
 *
 * @example
 * [hen-ui-avatar alt="Rebecca Long" fallback="RL" /]
 * [hen-ui-avatar src="https://…/photo.jpg" alt="Andrew Rice" fallback="AR" /]
 */
export const AvatarShortcode: ShortCode<AvatarShortcodeProps> = {
  component: ({ src, alt, fallback, size, badge }) => {
    if (!src && !fallback) return null;
    return (
      <Avatar
        src={src}
        alt={alt ?? fallback ?? ''}
        fallback={fallback}
        size={size}
        badge={badge === true || badge === 'true'}
      />
    );
  },
};
